import { Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, take } from "rxjs";
import { NotTranslatedApi } from "./not-translated.api";
import { LOCALSTORAGE_LOCALE_KEY } from "../locale/locale.service";

@Injectable({
  providedIn: 'root'
})
export class NotTranslatedService {
  private readonly loggedKeys = new Set<string>();

  constructor(private notTranslatedApi: NotTranslatedApi) {}

  notTranslated(key: string) {
    if (!key || key.endsWith(".info") || localStorage.getItem(LOCALSTORAGE_LOCALE_KEY) === "keys") return;
    if (this.loggedKeys.has(key)) return;

    this.loggedKeys.add(key);
    this.logMissingKey(key)
      .pipe(
        take(1),
        catchError(() => EMPTY),
      )
      .subscribe();
    console.log("No translation: ", key);
  }

  private logMissingKey(key: string): Observable<boolean> {
    return this.notTranslatedApi.logMissingKey(key);
  }
}
